import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {TicketBuyAndUseResultVo} from '../../common/shared/api/nicolas/vo/TicketBuyAndUseResultVo.interface';

/**
 * 단건 이용권 구매 & 사용
 *
 * Origin: pageNicolasApi.postTicketBuyAndUse
 * API: POST /api/v1/ticket/buy_and_use
 */
export async function postTicketBuyAndUse(
  {
    productId,
    ticketId,
  }: {
    productId: number;
    ticketId: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketBuyAndUseResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/buy_and_use',
    {
      method: 'POST',
      data: {
        product_id: productId,
        ticket_id: ticketId,
      },
    },
    options
  );
  return response.data;
}
